import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Home,
  Wrench,
  Package,
  QrCode,
  User,
} from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';

const navItems = [
  { path: '/dashboard', icon: Home, labelKey: 'nav.dashboard' },
  { path: '/work-orders', icon: Wrench, labelKey: 'nav.workOrders' },
  { path: '/inventory', icon: Package, labelKey: 'nav.inventory' },
  { path: '/scan', icon: QrCode, labelKey: 'nav.scan' },
  { path: '/profile', icon: User, labelKey: 'nav.profile' },
];

export default function MobileNav() {
  const { t } = useTranslation();
  const location = useLocation();
  const { user } = useAuth();

  // Navigation mobile visible for all users

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 md:hidden safe-area-bottom">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path ||
            (item.path !== '/dashboard' && location.pathname.startsWith(item.path));

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 h-full px-1 transition-colors ${
                isActive
                  ? 'text-blue-600 dark:text-blue-400'
                  : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
              }`}
            >
              <Icon className={`w-5 h-5 ${isActive ? 'stroke-2' : ''}`} />
              <span className="mt-1 text-[10px] font-medium truncate max-w-full">
                {t(item.labelKey, item.labelKey.split('.')[1])}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
